export enum Operation {
  EQ = 'EQ',
  GT = 'GT',
  GTE = 'GTE',
  LT = 'LT',
  LTE = 'LTE',
  BYTE_MASK = 'BYTE_MASK',
  INACTIVITY = 'INACTIVITY'
}
